// --------------------------------------------------------------------------
// #TBC - Chart Generator
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------
/*
 * App that creates requested type of Highcarts chart - either a bar or a pie
 */

'use strict';

var $ = window.$ = window.jQuery = require('jquery');
var Handlebars = require('handlebars');
var resetContainerHeight = require('./charting-reset-height');
var hideControls = require('./charting-hide-controls');
var colours = require('./charting-graph-colours')();
var Highcharts = require('../../../../node_modules/highcharts-release/highcharts.src');
require('highcharts-release/modules/exporting')(Highcharts);

module.exports = function () {

	//Chart config
	var options = {};
	var optionsCopy;
	var maxCount = 15;
	var chart;
	//DOM
	var $chartContainer = $('body').find('[data-binding="chart-container"]');
	var $chartWrapper = $('[data-bind="charting-charts-wrapper"]');
	var yAxisText = $('[data-bind="charting-axis-text"]').text();

	//Chart config constructor
	function Options(type, title, xAxis, series, pieData, colours) {
		this.chart = {
			type: type,
			renderTo: $chartContainer[0]
		};
		this.title = {
			text: null
		};
		this.xAxis = {
			categories: xAxis,
			tickInterval: 1,
			allowDecimals: false
		};
		this.yAxis = {
			tickInterval: 1,
			title: {
				enabled: true,
				text: yAxisText
			}
		};
		this.series = series;
		this.keys = xAxis;
		this.plotOptions = {
			pie: pieData,
			column: { colorByPoint: true },
			colorByPoint: true
		};
		this.colors = colours;
		this.exporting = {
			scale: 0.5
		};
	}

	function initControls(chartType) {
		$('.charting-pie-legend-editor input[type="number"]').each(function (index) {
			var thisCount = options.series[0].data[index];
			$(this).val(thisCount);
		});
		$('.charting-pie-legend-editor .input-number__button').off('click');
		//event delegation doesn't work for some reason
		//needs investigating
		$('.charting-pie-legend-editor .input-number__button').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			var thisBird = $(this).parent('.controls').siblings('.legend-text').children('.heading').text().trim();
			var inputCounter = $(this).siblings('input[type="number"]');
			var inputCounterVal = parseInt(inputCounter.val(), 10);

			var localMaxCount;

			if (chartType !== 'pie') {
				localMaxCount = maxCount;
			} else {
				localMaxCount = 9999;
			}

			//Match this item with data
			for (var i = 0; i < options.series[0].data.length; i++) {
				if (options.xAxis.categories[i] === thisBird) {
					if ($(this).hasClass('increase') && inputCounterVal < localMaxCount) {
						inputCounterVal += 1;
						inputCounter.val(inputCounterVal);
						//Update data and clone accordingly
						options.series[0].data[i] = inputCounterVal;
						optionsCopy.series[0].data[i] = inputCounterVal;
						chart.series[0].data[i].update(inputCounterVal, true, true);
					} else if ($(this).hasClass('decrease') && inputCounterVal > 0) {
						inputCounterVal -= 1;
						inputCounter.val(inputCounterVal);
						//Update data and clone accordingly
						options.series[0].data[i] = inputCounterVal;
						optionsCopy.series[0].data[i] = inputCounterVal;
						chart.series[0].data[i].update(inputCounterVal, true, true);
					}

					//Restore data after Highcharts
					//alters it via setData
					options.series[0].data = optionsCopy.series[0].data;
				}
			}
		});
	}

	function showControls(data, chartType) {
		if ($('.charting-pie-legend-editor').length === 0) {
			var stringHtml = document.getElementById('pie-legend-editor').innerHTML;
			var template = Handlebars.compile(stringHtml);
			var html = template(data);
			$(html).insertAfter($chartWrapper);
			//Store a copy of the data
			//So that it can be restored
			//before Highcharts overwrites it via setData
			optionsCopy = $.extend(true, {}, options);
			//Add event handlers for controls
			initControls(chartType);
		}
	}

	function setChartHeight(axisLabels) {
		var increment = 500 / axisLabels.length;
		var padding = 50;
		var newHeight = padding + axisLabels.length * (increment + 16);
		$chartContainer.css({ position: 'absolute' });
		$chartWrapper.css({ height: newHeight });
	}

	function createChart(options) {
		//Destroy previous
		if (chart !== undefined) {
			chart.destroy();
		}
		// Intialise chart
		chart = new Highcharts.Chart(options);
	}

	function getColoursArray() {
		var newColours = [];
		for (var i = 0; i < colours.length; i++) {
			newColours.push('#' + colours[i]);
		}
		return newColours;
	}

	function pieDataOptions(axisLabels, chartSeries) {
		var seriesArr = [];
		var pieData = {
			data: []
		};
		for (var i = 0; i < chartSeries[0].data.length; i++) {
			var birdName = axisLabels[i];
			var birdCount = chartSeries[0].data[i];
			seriesArr.push([birdName, birdCount]);
		}
		pieData.data = seriesArr;
		return pieData;
	}

	function loadChart(chartType, chartName, axisLabels, chartSeries, dataDetail, isEditable) {
		var colours = getColoursArray();
		//Create generic set of options
		options = new Options(chartType, chartName, axisLabels, chartSeries, null, colours);
		//If pie create unique set of options
		if (chartType === 'pie') {
			var pieData = pieDataOptions(axisLabels, chartSeries);
			var pieChartSeries = [{
				type: chartType,
				name: chartName
			}];
			var pieOptions = new Options(chartType, chartName, axisLabels, pieChartSeries, pieData, colours);
			resetContainerHeight();
			createChart(pieOptions);
		}
		//If any othe type of chart
		else {
				setChartHeight(axisLabels);
				createChart(options);
			}
		//For juniors, show numbers editors
		if (isEditable) {
			showControls(dataDetail, chartType);
		} else {
			hideControls();
		}
	}

	return {
		loadChart: loadChart
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-generator.js
// module id = 234
// module chunks = 0